import client from '../httpClient';

const smsGetUnsendApi = (params) => {
  return client.get('/sms/unsend', { params });
};

export default smsGetUnsendApi;
